// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "../Utilities/LoggerUtils.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as CustomPaymentMethodsConfig$OrcaPaymentPage from "../Hooks/CustomPaymentMethodsConfig.bs.js";

function saveDetailsCssStyle(themeObj) {
  return ".container {\n  display: flex;\n  cursor: pointer;\n  position: relative;\n}\n\n.container input {\n  position: absolute;\n  transform: scale(0);\n}\n\n.container input:checked ~ .checkmark {\n  transform: rotate(45deg);\n  height: 1em;\n  width: .4em;\n  border-color: " + themeObj.colorTextSecondary + ";\n  border-top-color: transparent;\n  border-left-color: transparent;\n  border-radius: 0;\n  margin-top: -2px;\n  margin-left: 8px;\n}\n\n.container .checkmark {\n  display: block;\n  width: 1em;\n  height: 1em;\n  border: 2px solid " + themeObj.colorTextSecondary + ";\n  border-radius: 2px;\n  transition: all .3s;\n}\n";
}

function SaveDetailsCheckbox(props) {
  var setIsChecked = props.setIsChecked;
  var isChecked = props.isChecked;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var showPaymentMethodsScreen = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.showPaymentMethodsScreen);
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var customMessageForCardTerms = match$1.customMessageForCardTerms;
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var customCardPaymentConfig = CustomPaymentMethodsConfig$OrcaPaymentPage.useCustomPaymentMethodConfigs("card", "debit");
  var customMessageConfig = Core__Option.getOr(Core__Option.map(customCardPaymentConfig, (function (config) {
              return config.message;
            })), PaymentType$OrcaPaymentPage.defaultPaymentMethodMessage);
  var css = saveDetailsCssStyle(match.themeObj);
  var onChange = function (ev) {
    var target = ev.target;
    var value = target.checked;
    LoggerUtils$OrcaPaymentPage.logInputChangeInfo("saveDetails", loggerState);
    setIsChecked(function (param) {
          return value;
        });
  };
  var match$2 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match$2.localeString;
  var match$3 = isChecked ? [
      "Checkbox--checked",
      "CheckboxInput--checked",
      "CheckboxLabel--checked"
    ] : [
      "",
      "",
      ""
    ];
  var checkedState = match$3[1];
  var customMessageConfigValue = Core__Option.getOr(customMessageConfig.value, "");
  var saveCardCheckboxLabel = showPaymentMethodsScreen ? localeString.saveCardDetails : (
      customMessageConfigValue.length > 0 ? customMessageConfigValue : (
          customMessageForCardTerms.length > 0 ? customMessageForCardTerms : localeString.cardTerms(match$1.business.name)
        )
    );
  return React.createElement("div", {
              "aria-label": isChecked ? "Deselect to avoid saving card details" : "Select to save card details",
              "aria-checked": isChecked ? "true" : "false",
              className: "Checkbox " + match$3[0] + " flex flex-row gap-2 items-center",
              role: "checkbox",
              tabIndex: 0,
              onKeyDown: (function ($$event) {
                  var key = $$event.key;
                  var keyCode = $$event.keyCode;
                  if (key === "Enter" || keyCode === 13) {
                    return setIsChecked(function (prev) {
                                return !prev;
                              });
                  }
                  
                })
            }, React.createElement("style", undefined, css), React.createElement("label", {
                  className: "container CheckboxInput " + checkedState
                }, React.createElement("input", {
                      tabIndex: -1,
                      checked: isChecked,
                      type: "checkbox",
                      onChange: onChange
                    }), React.createElement("div", {
                      className: "checkmark CheckboxInput " + checkedState
                    }), React.createElement("div", {
                      className: "CheckboxLabel " + match$3[2] + " ml-2 w-11/12 opacity-50 text-xs"
                    }, saveCardCheckboxLabel)));
}

var make = SaveDetailsCheckbox;

export {
  saveDetailsCssStyle ,
  make ,
}
/* react Not a pure module */
